import { hasKey } from "../../exports/helpers.js";
export default function getUniqueValues(data, key) {
    hasKey(data, key);
    const uniques = [...new Set(data.map((d) => d[key]))];
    return uniques;
}
//# sourceMappingURL=getUniqueValues.js.map